exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nimg[data-v-78a6d0cf] {\n  width: 100px;\n  height: 100px;\n}\n.column[data-v-78a6d0cf] {\n  text-align: center;\n}\n.item[data-v-78a6d0cf] {\n  padding: 10px;\n  background: rgb(35, 42, 47, .5);\n  border: 2px solid rgb(255, 255, 255, .1);\n  border-radius: 6px;\n}\n.release-info[data-v-78a6d0cf] {\n  padding-left: 10px;\n  font-size: 13px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\nsmall[data-v-78a6d0cf] {\n  display: block;\n  font-size: 10px;\n  color: gray;\n}\n", ""]);

// exports
